import React, { useEffect, useState } from "react";
import {
  Animated,
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
} from "react-native";
import { IconButton } from "react-native-paper";

const CustomHeader = ({ title, scrollY, navigation, image }: any) => {
  if (scrollY.interpolate === undefined) {
    return null;
  }

  const [titleMaxLines, setTitleMaxLines] = useState<number>(2);
  const { width } = useWindowDimensions();
  // Define the animation configuration
  //Colors
  const titleColor = scrollY.interpolate({
    inputRange: [0, 100],
    outputRange: ["black", "white"],
    extrapolate: "clamp",
  });

  const layerColor = scrollY.interpolate({
    inputRange: [0, 100],
    outputRange: ["rgba(0,0,0,0)", "rgba(0,0,0,0.4)"],
    extrapolate: "clamp",
  });

  const buttonBackgroundColor = scrollY.interpolate({
    inputRange: [0, 100],
    outputRange: ["rgba(0,0,0,0.6)", "rgba(0,0,0,0)"],
    extrapolate: "clamp",
  });

  const headerHeight = scrollY.interpolate({
    inputRange: [0, 100], // The range of scroll values to apply the animation
    outputRange: [200, 100], // The range of header heights corresponding to the scroll values
    extrapolate: "clamp", // Keep the animation within the defined output range
  });

  const titleTranslateY = scrollY.interpolate({
    inputRange: [0, 100],
    outputRange: [0, -70], // Move the title from below to the top of the header
    extrapolate: "clamp",
  });

  const titlePaddingStart = scrollY.interpolate({
    inputRange: [0, 100],
    outputRange: [20, 60],
    extrapolate: "clamp",
  });

  // Listen to the value of scrollY
  useEffect(() => {
    const id = scrollY.addListener(({ value }: any) => {
      if (value < 40 && titleMaxLines === 1) {
        setTitleMaxLines(2);
      } else if (value > 100 && titleMaxLines === 2) {
        setTitleMaxLines(1);
      }
    });

    // Cleanup listener when component unmounts
    return () => {
      scrollY.removeListener(id);
    };
  }, [scrollY, titleMaxLines]);

  return (
    <>
      <Animated.View style={[styles.headerContainer, { height: headerHeight }]}>
        <ImageBackground
          source={image}
          style={[StyleSheet.absoluteFillObject, styles.headerImage]}
          resizeMode="cover"
        >
          {/*a layer above the image */}
          <Animated.View
            style={{ backgroundColor: layerColor, height: headerHeight, width }}
          />

          <IconButton
            icon="arrow-left"
            iconColor="#FFFFFF"
            size={24}
            onPress={() => navigation.goBack()}
            style={[
              styles.backButton,
              { backgroundColor: buttonBackgroundColor },
            ]}
          />
        </ImageBackground>
      </Animated.View>

      <Animated.Text
        numberOfLines={titleMaxLines}
        style={[
          styles.title,
          {
            color: titleColor,
            paddingLeft: titlePaddingStart,
            paddingRight: 20,
            width: width,
            transform: [{ translateY: titleTranslateY }],
          },
        ]}
      >
        {title}
      </Animated.Text>
    </>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    backgroundColor: "transparent",
    overflow: "visible",
  },
  backButton: {
    position: "absolute",
    left: 0,
  },
  title: {
    textAlign: "left",
    backgroundColor: "transparent",
    color: "#000",
    fontFamily: "Poppins-bold",
    fontSize: 32,
    fontWeight: "bold",
  },
  headerImage: {
    alignItems: "center",
    justifyContent: "center",
  },
});

export default CustomHeader;
